@if (dadosSaude) {
  <div class="main">
    <div class="summary-view">
      <header class="summary-header">
        <a
          class="back-btn"
          href="/chat"
          aria-label="Voltar"
          style="background-color: #fff;"
        >
          <img src="../../../assets/svg/icons/arrow_left.svg" alt="Voltar" />
        </a>

        <h1>Olá, {{ nomePessoa }}!</h1>
      </header>

      <section class="summary-panel" style="background-color: #fff">
        <div class="panel-head">
          <div class="panel-title">
            <h2>Resumo de Saúde</h2>
            <p>{{ formaterDataParaTextoAmigavel(dataSelecionada) }}</p>
          </div>

          <button class="filter-btn" type="button" (click)="openFiltroData()">
            <mat-icon>filter_list</mat-icon>
            Filtrar data
          </button>
        </div>

        <!-- CLASSIFICAÇÃO DE DOR -->
        <article 
        class="summary-card score-card" 
        style="background-color: #8395a514"
        >
          <div class="card-copy">
            <p class="card-label">Sua classificação de dor:</p>
            <h3>{{ mapperDorToComponentSetup().text }}</h3>
          </div>

        <span
          class="icon-chip"
          [style.background-color]="mapperDorToComponentSetup().corFundoIcone"
          >{{ dadosSaude?.movia?.classificacaoDor }}</span
        >
      </article>

        <!-- POSTURA -->
        <article
          class="summary-card posture-card"
          [style.background-color]="mapperPosturaToComponentSetup().corFundo"
        >
          <div class="card-copy">
            <p class="card-label">Melhora na postura:</p>
            <h3>{{ mapperPosturaToComponentSetup().text }}</h3>
          </div>

          <div
            class="icon-chip"
            [style.background-color]="mapperPosturaToComponentSetup().corFundo"
          >
            <mat-icon [style.color]="mapperPosturaToComponentSetup().corPrimaria">
              directions_walk
            </mat-icon>
          </div>
        </article>

      <!-- Risco -->
      <article
        class="summary-card risk-card"
        [style.background-color]="
          mapperRiscoFisicoPsicossociaisToComponentSetup().corFundo
        "
      >
        <div class="card-copy">
          <h3>
            {{ mapperRiscoFisicoPsicossociaisToComponentSetup().text }}
          </h3>
        </div>
        <span
          class="icon-chip"
          [style.background-color]="
            mapperRiscoFisicoPsicossociaisToComponentSetup().corFundo
          "
        >
          @if (
            dadosSaude?.movia?.riscoFisicoPsicossociais === 0 ||
            dadosSaude?.movia?.riscoFisicoPsicossociais === 1
          ) {
            <img
              src="../../../assets/svg/icons/favorite.svg"
              alt=""
              [style.color]="
                mapperRiscoFisicoPsicossociaisToComponentSetup().corPrimaria
              "
            />
          }

          @if (
            dadosSaude?.movia?.riscoFisicoPsicossociais === 2 ||
            dadosSaude?.movia?.riscoFisicoPsicossociais === 3
          ) {
            <img
              src="../../../assets/svg/icons/warning.svg"
              alt=""
              [style.color]="
                mapperRiscoFisicoPsicossociaisToComponentSetup().corPrimaria
              "
            />
          }
        </span>
      </article>
    </section>
  </div>
</div>

  <app-saude-resumo-modal-datas
    [open]="modalOpen"
    [title]="modalTitle"
    [subtitle]="modalSubtitle"
    [mode]="modalMode"
    [options]="modalOptions"
    [selectedId]="selectedId"
    [selectedIds]="selectedIds"
    (confirm)="onConfirmModal($event)"
    (close)="closeModal()"
  />
} @else {
  <div class="main">
    <div class="summary-view">
      <header class="summary-header">
        <a
          class="back-btn"
          href="/chat"
          aria-label="Voltar"
          style="background-color: #fff;"
        >
          <img src="../../../assets/svg/icons/arrow_left.svg" alt="Voltar" />
        </a>

        <h1>Olá, {{ nomePessoa }}!</h1>
      </header>

      <section class="summary-panel" style="background-color: #fff">
        <div class="panel-head">
          <div class="panel-title">
            <h2>Resumo de Saúde</h2>
          </div>
        </div>

        <article class="summary-card score-card" style="background-color: #8395A514">
          <div class="card-copy">
            <h3>Você ainda não possui dados de saúde registrados.</h3>
          </div>
          <span
            class="icon-chip"
            style="background-color: #8395A514";
          >
          <img src="../../../assets/svg/icons/favorite_gray.svg" alt="">
          </span>
        </article>
      </section>
    </div>
  </div>

  <app-saude-resumo-modal-datas
    [open]="modalOpen"
    [title]="modalTitle"
    [subtitle]="modalSubtitle"
    [mode]="modalMode"
    [options]="modalOptions"
    [selectedId]="selectedId"
    [selectedIds]="selectedIds"
    (confirm)="onConfirmModal($event)"
    (close)="closeModal()"
  />
}
